<template>
  <div>
    <v-container>
      <v-row justify="space-around" align="center">
        <v-col sm="12" md="8" lg="8">
          <v-card>
            <v-card-title>
              <h2>Profile Details</h2>

              <v-spacer></v-spacer>
              <!--<v-speed-dial-->
              <!--v-model="formSeen"-->
              <!--small-->
              <!--right-->
              <!--direction="left"-->
              <!--color="#00a7d3"-->
              <!--transition="slide-y-transition"-->
              <!--&gt;-->
              <!--<template v-slot:activator>-->
              <!--<v-btn-->
              <!--v-model="formSeen"-->
              <!--@click="postChanges"-->
              <!--fab-->
              <!--:color="formSeen? 'green': 'blue'"-->
              <!--dark-->
              <!--&gt;-->
              <!--<v-icon>edit</v-icon>-->
              <!--<v-icon>check</v-icon>-->
              <!--</v-btn>-->
              <!--</template>-->

              <!--<v-btn-->
              <!--fab-->
              <!--dark-->
              <!--color="red"-->
              <!--@click="resetNewValues">-->
              <!--<v-icon>close</v-icon>-->
              <!--</v-btn>-->

              <!--</v-speed-dial>-->
            </v-card-title>
            <v-divider color="#42A5F5"></v-divider>
            &nbsp
            <v-card-title>
              <h3 class="indigo--text text--darken-2">User Details</h3>
            </v-card-title>

            <v-row justify="center">
              <v-col md="8" sm="12">
                <div v-for="(info, index) in headers">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <h4 class="raleway-bold">
                          {{info}}
                        </h4>
                        </v-list-item-content>
                      <v-list-item-content v-if="!formSeen" class="align-end">
                        <h4>{{selectedFieldsValues[index]}}</h4>
                      </v-list-item-content>
                      <v-list-item-content class="align-end" v-else>
                        <v-text-field
                          v-model="newValues[index]"
                          class="end-align-input"
                        >
                        </v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                </div>
              </v-col>
            </v-row>

            &nbsp
            <v-card-title>
              <h3 class="indigo--text text--darken-2">Client Details</h3>
            </v-card-title>

            <v-row justify="center">
              <v-col md="8" sm="12">
                <div v-for="(info, index) in clientHeaders">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <h4 class="raleway-bold">
                          {{info}}
                        </h4>
                      </v-list-item-content>
                      <v-list-item-content class="align-end">
                       <h4>{{clientFields[index]}}</h4>
                      </v-list-item-content>

                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                </div>
              </v-col>
            </v-row>

            <v-row justify="space-around" v-if="login_method === 'password'">
              <v-col cols="4">
                <v-btn
                  color="blue darken-1"
                  block
                  text
                  @click="passwordChange=true"
                >
                  Change my password
                </v-btn>
              </v-col>
            </v-row>

          </v-card>
        </v-col>

      </v-row>
    </v-container>


    <v-dialog
      v-model="passwordChange"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title class="justify-center">
          <h2>Change password</h2>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col cols="12">
                <h3>Old password</h3>
                <v-text-field v-model="oldPassword" type="password"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12">
                <h3>New password</h3>
                <v-text-field v-model="newPassword1" type="password"></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12">
                <h3>Retype new password</h3>
                <v-text-field v-model="newPassword2" type="password"
                              :rules="[rulePassword2.passwordMatch]"></v-text-field>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="passwordChange=false; resetPasswords()">Cancel</v-btn>
          <v-btn text color="blue darken-1" @click="changePassword">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="unmatchedPassword"
      max-width="500px"
      class="authent-error"
      @keydown.enter="alert=false"
      @keydown.esc="alert=false"
    >
      <v-card>
        <v-card-title>
          Authentication Error
        </v-card-title>
        <v-card-text>
          Make sure both password are identical.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            class="authent-error"
            color="blue darken-1"
            @click="unmatchedPassword=false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Settings",
        data() {
            return {
                headers: ["First Name", "Last Name", "Email"],
                clientHeaders: ["Client Name"],
                selectedFieldsValues: [],
                clientFields: [],
                newValues: null,
                formSeen: false,
                passwordChange: false,
                passwordSeen: false,
                oldPassword: '',
                newPassword1: '',
                newPassword2: '',
                unmatchedPassword: false,
                rulePassword2: {passwordMatch: value => value === this.newPassword1},
                rules: {
                    required: value => !!value || 'Required.',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail'
                    }
                },
                login_method: null,
            }
        },

        methods: {
            resetPasswords() {
                this.oldPassword = null;
                this.newPassword1 = null;
                this.newPassword2 = null;
            },
            checkPassword() {
                if (this.newPassword1.length > 0 && this.newPassword2.length > 0) {
                    if (this.newPassword1 !== this.newPassword2) {
                        return false
                    } else {
                        // Change Password and post changes through the API
                        return true
                    }
                } else {
                    return false
                }
            },
            changePassword() {
                if (this.checkPassword()) {
                    axios.post(process.env.API_URL + '/users/changepass',
                        JSON.parse(JSON.stringify({
                            old_password: this.oldPassword,
                            new_password: this.newPassword1,
                            verify_password: this.newPassword2
                        })))
                        .then((response) => {
                            this.$store.commit('displaySnackbar','Password Changed');

                            this.passwordChange = false;
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + error);

                        })
                } else {
                    this.$store.commit('displaySnackbar', 'Make sure you typed twice the same new password');
                }
            },

            getSelectedFields() {
                // for (var i = 0; i < Object.keys(this.profile.user).length; i++) {
                //   if (this.headers.includes(Object.keys(this.profile.user)[i])) {
                //     this.selectedFieldsValues.push(Object.values(this.profile.user)[i]);
                //     this.newValues.push(Object.values(this.profile.user)[i]);
                //   }
                // }
                this.selectedFieldsValues.push(this.$store.state.auth.user.first_name, this.$store.state.auth.user.last_name, this.$store.state.auth.user.email);
                this.clientFields.push(this.$store.state.auth.client.name);
                this.newValues = JSON.parse(JSON.stringify(this.selectedFieldsValues));
            },


            postChanges() {
                if (this.formSeen) {
                    // Posts Changes in the profile on the API
                    this.formSeen = false;
                    this.selectedFieldsValues = JSON.parse(JSON.stringify(this.newValues));
                    this.$store.commit('displaySnackbar', 'Profile Details Modified');
                    this.formSeen = !this.formSeen;
                } else {
                }
            },

            postChangePassword() {

            },

            resetNewValues() {
                if (this.formSeen) {
                    // Resets newValues to the former values stored in selectedFieldsValues
                    this.newValues = [];
                    this.newValues = JSON.parse(JSON.stringify(this.selectedFieldsValues));
                } else {
                }
            }

        },

        mounted() {
            this.getSelectedFields();

            this.login_method = this.$store.state.auth.login_method;

        },

    }
</script>

<style scoped>
  .end-align-input input {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings.vue